import axios, { AxiosPromise }                from 'axios';
import { Layout }                             from '@/components/chart/chart.types';
import { chartUuidMock }                      from '@/helpers/variables';
import { ChartPosition }                      from '@/components/chart/helpers/chart-variables';
import { FilterStylesObject, SelectedFilter } from '@/components/filter-panel/filter-panel.types';
import { GeneralTabs }                        from '@/views/lead-time/lead-time.types';
import { ObjectWithStringKeys }               from '@/types';
import { FilterConfiguration }                from '@/components/chart/chart-wrapper/store/chart-wrapper.state.store';
import { client }                             from '@/service/client';

const call: ObjectWithStringKeys<any> = {
  segments: '',
  outlet: '',
};

export const getLeadTimeChartDataService = (filters: Partial<SelectedFilter>[], functions: string[], trackedTabName: string, leadFilter: string): AxiosPromise => {
  const tabName: string = trackedTabName ? trackedTabName.toUpperCase() : GeneralTabs.SEGMENTS.toUpperCase();

  if (call[ trackedTabName ]) {
    call[ trackedTabName ].cancel();
  }

  call[ trackedTabName ] = axios.CancelToken.source();

  return client.post('/reports/lead-time/data', { filters, functions, tabName, leadFilter },
    {
      cancelToken: call[ trackedTabName ].token,
    });
};

export const getAvailableLeadTimeFiltersAndFunctions = (): AxiosPromise => client.get('/reports/lead-time/filters-section');

export function getChartLayoutService(): Promise<Layout[]> {
  return new Promise((resolve) => {
    resolve([
      { chartUuid: chartUuidMock, layoutCode: ChartPosition.TOP_LEFT },
    ]);
  });
}

export function getLeadTimeChartSettings(): AxiosPromise {
  return client.get('/reports/lead-time-view-configuration');
}

export function saveLeadTimeChartSettings(payload: ObjectWithStringKeys<boolean>): AxiosPromise {
  return client.put('/reports/lead-time-view-configuration', payload);
}

export function getLeadTimeFilterAllConfigurations(): AxiosPromise {
  return client.get('/reports/lead-time/filter-snapshot');
}

export function getLeadTimeFilterConfiguration(configurationName: string): AxiosPromise {
  return client.get(`/reports/lead-time/filter-snapshot/${configurationName}`);
}

export function createLeadTimeFilterConfiguration(configuration: FilterConfiguration): AxiosPromise {
  return client.put('/reports/lead-time/filter-snapshot', { ...configuration });
}

export function removeLeadTimeFilterConfiguration(configurationName: string): AxiosPromise {
  return client.delete(`/reports/lead-time/filter-snapshot/${configurationName}`);
}

export function saveLeadTimeFiltersStylesConfiguration(filtersConfig: FilterStylesObject): AxiosPromise {
  return client.put('/reports/lead-time/filters-section', filtersConfig);
}
